/* React */
import React from "react";

/* Components */
import ValueInput from "src/components/shared/slider/double-slider/value-input/ValueInput";

/* Stylesheet */
import styles from "./ValueContainer.module.scss";

/* Interfaces */
interface ValueContainerProps {
  className?: string;
  min: number;
  max: number;
  value?: {
    lower: number;
    upper: number;
  };
  disabled?: boolean;
  onChange: (value: { lower: number; upper: number }) => void;
}

const ValueContainer: React.FC<ValueContainerProps> = ({
  className,
  min,
  max,
  value,
  disabled,
  onChange,
}) => {
  return (
    <div className={`${styles.value_container} ${styles[className ?? ""]}`}>
      <ValueInput
        className={className}
        label={`${min}`}
        value={value?.lower ?? min}
        min={min}
        max={value?.upper ?? max}
        isLower={true}
        disabled={disabled}
        onChange={(newLower) => {
          onChange({ lower: newLower, upper: value?.upper ?? max });
        }}
      />
      <ValueInput
        className={className}
        label={`${max}`}
        value={value?.upper ?? max}
        min={value?.lower ?? min}
        max={max}
        isLower={false}
        disabled={disabled}
        onChange={(newUpper) => {
          onChange({ lower: value?.lower ?? min, upper: newUpper });
        }}
      />
    </div>
  );
};

export default ValueContainer;
